import { Button, ButtonColor, ButtonTheme } from '@cian/button-component';
import * as React from 'react';

import { RemoveModalFrame, TRemoveModalFrame } from '../../../../../store/popups/remove';
import { Layout } from '../layout';
import * as styles from './index.css';
import * as Analytics from './tracking';

export interface IInitialProps {
  changeActiveFrame(newActiveFrame: TRemoveModalFrame): void;
  close(): void;
}

export class Initial extends React.PureComponent<IInitialProps, {}> {
  public componentDidMount() {
    Analytics.trackDeleteWindowShowed();
  }

  public render() {
    return (
      <Layout className={styles['container']} title="Удалить объявление?">
        <p className={styles['subtitle']}>
          Объявление будет удалено, все данные по нему будут утеряны. Вы можете перенести его в архив. Плата за хранение
          в архиве не взимается.
        </p>
        <blockquote className={styles['description']}>
          Напоминаем, что неактуальные объявления должны быть сняты с публикации (удалены или перенесены в архив).
          Аккаунты с неактуальными объявлениями подлежат пессимизации, штрафам и блокировке.
        </blockquote>
        <footer className={styles['footer']}>
          <Button className={styles['archive']} onClick={this.archive}>
            Перенести в архив
          </Button>
          <Button color={ButtonColor.Danger} onClick={this.remove} theme={ButtonTheme.Ghost}>
            Удалить
          </Button>
          <Button className={styles['cancel']} onClick={this.cancel} theme={ButtonTheme.Ghost}>
            Отменить
          </Button>
        </footer>
      </Layout>
    );
  }

  private archive = () => {
    Analytics.trackArchiveButtonClicked();
    this.props.changeActiveFrame(RemoveModalFrame.Archive);
  };

  private remove = () => {
    Analytics.trackRemoveButtonClicked();
    this.props.changeActiveFrame(RemoveModalFrame.Remove);
  };

  private cancel = () => {
    Analytics.trackCancelButtonClicked();
    this.props.close();
  };
}
